import { request } from '../../helpers/api/request';

export const deleteFaq = async (id: number) => {
    const { data } = await request({
        url: `admin/faq/${id}`,
        method: 'DELETE',
    });

    return data;
};
